import { nowAsMoment } from 'utils/date/now.util';

export const getCurrentWeekDateString = () => {
  const currentDate = nowAsMoment();
  const isoWeek = currentDate.isoWeek();
  const year = currentDate.isoWeekYear();
  return `${isoWeek}W${year}`;
};
